import { CustomerInfoProviderInterface } from "@lib/CustomerInfoProvider/CustomerInfoProviderInterface";
import { TokenManagerModule } from "@modules/token_manager/TokenManagerModule";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { ROLE } from "./constants";

export class CurrentTokenChecker {
    public constructor(
        private readonly customerInfoProvider: CustomerInfoProviderInterface,
        private readonly tokenManagerModule: TokenManagerModule,
        private readonly logger: LoggerInterface
    ) {}

    public check() {
        // Reset JWT after logout
        if (
            !this.customerInfoProvider.getId() &&
            this.tokenManagerModule.exports.tokenManager.getTokenPayload()?.data
                .role === ROLE.Customer
        ) {
            this.logger.debug("Reset token, after loguout");
            this.tokenManagerModule.exports.tokenManager.discardToken();
        }

        // Reset JWT if shopifyCustomerId in JWT not equal customerId from customerInfoProvider(liquid)
        if (
            this.tokenManagerModule.exports.tokenManager.getTokenPayload()?.data
                .shopifyCustomerId &&
            this.tokenManagerModule.exports.tokenManager.getTokenPayload()?.data
                .shopifyCustomerId !== this.customerInfoProvider.getId()
        ) {
            this.logger.debug(
                "Reset token, because the token was created for another customer"
            );
            this.tokenManagerModule.exports.tokenManager.discardToken();
        }
    }
}
